module.exports = __webpack_public_path__ + "img/convergists6.41e08dd0.png";